import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\AdEventController::store
* @see app/Http/Controllers/Api/AdEventController.php:13
* @route '/api/ad/events'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/ad/events',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\AdEventController::store
* @see app/Http/Controllers/Api/AdEventController.php:13
* @route '/api/ad/events'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\AdEventController::store
* @see app/Http/Controllers/Api/AdEventController.php:13
* @route '/api/ad/events'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const AdEventController = { store }

export default AdEventController